import { css, html } from "../helpers/webComponents";

const styles: string = css`
:host {
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(10px);
}
`;

export class KeypadComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderKeypad();

        // this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderKeypad(): HTMLElement {
        const element: HTMLElement = html`
        <div>
            <style>
                ${styles}
            </style>
            <div>
                <game-minikeypad></game-minikeypad>
            </div>
        </div>
        `;

        return element;
    }
}
